export default __webpack_public_path__ + "8162954d8cb3d49e60cd914c202368db.jpg";